/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadFieldOptionsRequest
 */
export interface LeadFieldOptionsRequest {
    /**
     * 
     * @type {string}
     * @memberof LeadFieldOptionsRequest
     */
    entityName: string;
    /**
     * 
     * @type {string}
     * @memberof LeadFieldOptionsRequest
     */
    fieldName: string;
}

/**
 * Check if a given object implements the LeadFieldOptionsRequest interface.
 */
export function instanceOfLeadFieldOptionsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entityName" in value;
    isInstance = isInstance && "fieldName" in value;

    return isInstance;
}

export function LeadFieldOptionsRequestFromJSON(json: any): LeadFieldOptionsRequest {
    return LeadFieldOptionsRequestFromJSONTyped(json, false);
}

export function LeadFieldOptionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadFieldOptionsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entityName': json['entityName'],
        'fieldName': json['fieldName'],
    };
}

export function LeadFieldOptionsRequestToJSON(value?: LeadFieldOptionsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entityName': value.entityName,
        'fieldName': value.fieldName,
    };
}

